/* Keep the unpublished Body Butter preview navigable without publishing it. */
(function () {
  'use strict';
  var bodyPath = '/products/wholeform-body-butter';
  var storageKey = 'wholeform-body-butter-preview-url';
  var current = new URL(window.location.href);
  var previewProduct = null;
  try {
    if (document.querySelector('#bb-purchase') && current.searchParams.has('preview_key')) {
      previewProduct = current.href;
      sessionStorage.setItem(storageKey, previewProduct);
    } else previewProduct = sessionStorage.getItem(storageKey);
  } catch (_) {}
  var themeId = current.searchParams.get('preview_theme_id');
  function updateLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var raw = link.getAttribute('href');
      if (!raw || raw[0] === '#' || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
      var target;
      try { target = new URL(raw, location.origin); } catch (_) { return; }
      if (target.origin !== location.origin) return;
      var shop = target.pathname === bodyPath || /wholeform-(liposomal-glutathione|clear-protein-strawberry)/.test(target.pathname);
      if (shop) {
        link.dataset.bbShop = 'true';
        target = new URL(previewProduct || bodyPath, location.origin);
      }
      if (themeId && !target.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id', themeId);
      if (themeId) target.searchParams.set('pb', '0');
      link.href = target.href;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks);
  else updateLinks();
  document.addEventListener('shopify:section:load', updateLinks);
})();
